module.exports = __webpack_public_path__ + "img/fastvaluedeal-card-basic.477031bc.png";